<div *ngIf="showGroup">
  <div class="row">
    <div class="col col-xs-12 col-sm-6">
      <app-label [control]="vorversicherungsUnternehmen" class="custom-select__label" [for]="antrag_vorversicherungsUnternehmen">{{ isKfz ? expertMode ? 'Innerhalb des letzten Jahres versichert bei' : 'Ich war innerhalb des letzten Jahres versichert bei' : expertMode ? 'Bei welcher Versicherung?' : 'Bei welcher Versicherung sind / waren Sie?' }}</app-label>
      <mat-form-field>
        <input type="text" matInput [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" [formControl]="vorversicherungsUnternehmen" [matAutocomplete]="autoGroup">
        <mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="lookupService.displayValue">
          <mat-optgroup *ngFor="let group of versicherungGroupOptions | async" [label]="group.letter">
            <mat-option *ngFor="let value of group.values" [value]="value">
              {{ value.Value }}
            </mat-option>
          </mat-optgroup>
        </mat-autocomplete>
        <mat-error *ngIf="vorversicherungsUnternehmen.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </mat-form-field>
      <div class="input" *ngIf="showSonstigeVersicherung">
        <app-label [control]="sonstigeVersicherung" class="input__label" for="antrag_showSonstigeVersicherung">Sonstige Versicherung:</app-label>
        <mat-form-field>
          <input matInput id="antrag_showSonstigeVersicherung" [formControl]="sonstigeVersicherung">
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-6">
      <div class="input">
        <app-label [control]="polizzennummerVorversicherung" class="input__label" for="antrag_polizzennummerVorversicherung">{{ expertMode ? 'Wie lautet die bisherige Polizzennummer?' : 'Wie lautet Ihre bisherige Polizzennummer?' }}</app-label>
        <mat-form-field>
          <input matInput id="antrag_polizzennummerVorversicherung" [formControl]="polizzennummerVorversicherung">
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
